import contractallComponent from './contract.all.component';

let contractallModule = angular.module('contractall', [
])

.component('contractall', contractallComponent)

.name;

export default contractallModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/all/index.js